import { useState } from 'react';
import { useNavigate } from 'react-router';
import { CustomDialogBox } from '../components/molecules/CustomDialogBox';
import { formatCount } from '../helpers/syncResultHelpers';
import { inspectionRecordService } from '../services/inspection/inspectionRecordService';
import { signOutAndDeleteLocalData } from '../services/signOutService';

/**
 * The one sign-out check (#11590, SY-10): `requestSignOut` asks first when any Inspection
 * is not Delivered, because signing out deletes it. Render `signOutDialog` where it can be
 * seen once the control that asked has gone. `signOut` skips the check.
 */
export function useSignOut() {
  const navigate = useNavigate();
  const [undeliveredCount, setUndeliveredCount] = useState<number | null>(null);

  const signOut = async () => {
    await signOutAndDeleteLocalData();
    void navigate('/login?logout=true');
  };

  const requestSignOut = async () => {
    const count = await inspectionRecordService.countUndelivered();
    if (count === 0) return signOut();
    setUndeliveredCount(count);
  };

  const signOutDialog = (
    <CustomDialogBox
      title="Sign out?"
      isOpen={undeliveredCount !== null}
      description={`${formatCount(undeliveredCount ?? 0, 'inspection')} not yet synced will be deleted from this device.`}
      leftButtonText="SIGN OUT ANYWAY"
      rightButtonText="CANCEL"
      onLeftClick={() => void signOut()}
      onRightClick={() => setUndeliveredCount(null)}
      onBackdropClicked={() => setUndeliveredCount(null)}
      trigger={<div></div>}
    />
  );

  return { signOut, requestSignOut, signOutDialog };
}
